"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.filter.project': 'Filtrar por proyecto',
    'knowledge.filter.project.placeholder': 'Buscar proyectos...',
    'knowledge.filter.all_projects': 'Todos los proyectos',
    'knowledge.filter.assigned_only': 'Mostrar solo conocimiento asignado',
    'knowledge.filter.by_avatar': 'Filtrar por Avatar',
    'knowledge.filter.all_avatars': 'Todos los Avatares',
};
